<template>
  <vue-autosuggest
    :key="`${name}--autosuggest`"
    v-model="form.query"
    v-loading="loading"
    :suggestions="suggestions"
    :input-props="{
      id: 'autosuggest__input',
      placeholder: $t(`${base}.placeholder`),
      maxlength: 256,
      ariaLabel: `search`,
      name: `${name}--autosuggest__input`,
      enterkeyhint: 'done',
    }"
    :name="`${name}--autosuggest`"
    :get-suggestion-value="getSuggestionValue"
    @focus="handleFocus"
    @blur="handleBlur"
    @input="queryDebounce"
    @keyup.enter.native="handleSubmit"
    @selected="onSelected"
  >
    >
    <label
      slot="before-input"
      :for="`${name}--autosuggest__input`"
      class="before-input"
      :aria-label="$t(`general.search`)"
      :alt="$t(`general.search`)"
    >
      <i v-if="form.query" class="el-icon-close" @click="resetQuery" />
      <i
        v-else-if="!form.query && isFocus"
        class="el-icon-arrow-right"
        @click="handleBlur"
      />
      <i v-else-if="loading" v-loading="loading" class="el-icon-search" />
      <i v-else class="el-icon-search" @click="handleClick" />
    </label>
    <div slot="after-input" class="after-input">
      <el-button
        type="success"
        :disabled="!isValidQuery"
        @click="handleSubmit"
        >{{ $t(`${base}.btn`) }}</el-button
      >
    </div>

    <li
      v-for="s in sections"
      :slot="`before-section-${s}`"
      :key="`autocomplete-section-${s}`"
      class="item-search-header"
      >{{ $t(`${base}.types.${s}`) }}</li
    >

    <template slot-scope="{ suggestion }">
      <component :is="componentName(suggestion.name)" :item="suggestion.item" />
    </template>
  </vue-autosuggest>
</template>

<script>
/* webpackChunkName: "lad-search-category-basic" */ import LadSearchCategory from '@/components/search/components/suggestion/category-basic'
/* webpackChunkName: "lad-search-experience-basic" */ import LadSearchExperience from '@/components/search/components/suggestion/experience-basic'
/* webpackChunkName: "lad-search-package-basic" */ import LadSearchPackage from '@/components/search/components/suggestion/package-basic'
/* webpackChunkName: "lad-search-city-basic" */ import LadSearchCity from '@/components/search/components/suggestion/city-basic'
/* webpackChunkName: "lad-search-country-basic" */ import LadSearchCountry from '@/components/search/components/suggestion/country-basic'
/* webpackChunkName: "lad-search-continent-basic" */ import LadSearchContinent from '@/components/search/components/suggestion/continent-basic'
/* webpackChunkName: "lad-search-empty-basic" */ import LadSearchEmpty from '@/components/search/components/suggestion/empty-basic'
import LadSearchCommon from './common'

export default {
  name: 'LadSearchBasic',
  components: {
    LadSearchCategory,
    LadSearchExperience,
    LadSearchPackage,
    LadSearchCity,
    LadSearchCountry,
    LadSearchContinent,
    LadSearchEmpty,
  },
  extends: LadSearchCommon,
  methods: {
    handleSubmit() {
      if (!this.form.query) return

      /** se deja estatico el pathname xq no es necesario definirlo */
      this.handleLoading({
        target: { localName: 'a', pathname: `/category` },
      })

      this.$router.push({
        name: 'search',
        query: { q: this.form.query, type: 'experience' },
      })

      // this.resetQuery()
    },
  },
}
</script>
